(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[79],{

/***/ 41796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$n": function() { return /* binding */ lighten; },
/* harmony export */   "_j": function() { return /* binding */ darken; }
/* harmony export */ });
/* unused harmony exports hexToRgb, decomposeColor, colorChannel, private_safeColorChannel, recomposeColor, rgbToHex, hslToRgb, getLuminance, getContrastRatio, alpha, private_safeAlpha, private_safeDarken, private_safeLighten, emphasize, private_safeEmphasize, blend */
/* harmony import */ var _mui_utils_formatMuiErrorMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56535);
/* harmony import */ var _mui_utils_clamp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7610);

/* eslint-disable @typescript-eslint/naming-convention */

/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clampWrapper(value, min = 0, max = 1) {
  if (false) {}
  return (0,_mui_utils_clamp__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(value, min, max);
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */
function hexToRgb(color) {
  color = color.slice(1);
  const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
  let colors = color.match(re);
  if (colors && colors[0].length === 1) {
    colors = colors.map(n => n + n);
  }
  return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index) => {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', ')})` : '';
}
function intToHex(int) {
  const hex = int.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */
function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }
  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }
  const marker = color.indexOf('(');
  const type = color.substring(0, marker);
  if (['rgb', 'rgba', 'hsl', 'hsla', 'color'].indexOf(type) === -1) {
    throw new Error( false ? 0 : (0,_mui_utils_formatMuiErrorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(9, color));
  }
  let values = color.substring(marker + 1, color.length - 1);
  let colorSpace;
  if (type === 'color') {
    values = values.split(' ');
    colorSpace = values.shift();
    if (values.length === 4 && values[3].charAt(0) === '/') {
      values[3] = values[3].slice(1);
    }
    if (['srgb', 'display-p3', 'a98-rgb', 'prophoto-rgb', 'rec-2020'].indexOf(colorSpace) === -1) {
      throw new Error( false ? 0 : (0,_mui_utils_formatMuiErrorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(10, colorSpace));
    }
  } else {
    values = values.split(',');
  }
  values = values.map(value => parseFloat(value));
  return {
    type,
    values,
    colorSpace
  };
}

/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */
const colorChannel = color => {
  const decomposedColor = decomposeColor(color);
  return decomposedColor.values.slice(0, 3).map((val, idx) => decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
const private_safeColorChannel = (color, warning) => {
  try {
    return colorChannel(color);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
};

/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
function recomposeColor(color) {
  const {
    type,
    colorSpace
  } = color;
  let {
    values
  } = color;
  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i) => i < 3 ? parseInt(n, 10) : n);
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = `${values[1]}%`;
    values[2] = `${values[2]}%`;
  }
  if (type.indexOf('color') !== -1) {
    values = `${colorSpace} ${values.join(' ')}`;
  } else {
    values = `${values.join(', ')}`;
  }
  return `${type}(${values})`;
}

/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */
function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }
  const {
    values
  } = decomposeColor(color);
  return `#${values.map((n, i) => intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}

/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */
function hslToRgb(color) {
  color = decomposeColor(color);
  const {
    values
  } = color;
  const h = values[0];
  const s = values[1] / 100;
  const l = values[2] / 100;
  const a = s * Math.min(l, 1 - l);
  const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  let type = 'rgb';
  const rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }
  return recomposeColor({
    type,
    values: rgb
  });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  color = decomposeColor(color);
  let rgb = color.type === 'hsl' || color.type === 'hsla' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(val => {
    if (color.type !== 'color') {
      val /= 255; // normalized
    }
    return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
  });

  // Truncate at 3 digits
  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */
function getContrastRatio(foreground, background) {
  const lumA = getLuminance(foreground);
  const lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}

/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function alpha(color, value) {
  color = decomposeColor(color);
  value = clampWrapper(value);
  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  if (color.type === 'color') {
    color.values[3] = `/${value}`;
  } else {
    color.values[3] = value;
  }
  return recomposeColor(color);
}
function private_safeAlpha(color, value, warning) {
  try {
    return alpha(color, value);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clampWrapper(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color);
}
function private_safeDarken(color, coefficient, warning) {
  try {
    return darken(color, coefficient);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clampWrapper(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  } else if (color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (1 - color.values[i]) * coefficient;
    }
  }
  return recomposeColor(color);
}
function private_safeLighten(color, coefficient, warning) {
  try {
    return lighten(color, coefficient);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color, coefficient = 0.15) {
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
function private_safeEmphasize(color, coefficient, warning) {
  try {
    return emphasize(color, coefficient);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */
function blend(background, overlay, opacity, gamma = 1.0) {
  const blendChannel = (b, o) => Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
  const backgroundColor = decomposeColor(background);
  const overlayColor = decomposeColor(overlay);
  const rgb = [blendChannel(backgroundColor.values[0], overlayColor.values[0]), blendChannel(backgroundColor.values[1], overlayColor.values[1]), blendChannel(backgroundColor.values[2], overlayColor.values[2])];
  return recomposeColor({
    type: 'rgb',
    values: rgb
  });
}

/***/ }),

/***/ 54071:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/telegram",
      function () {
        return __webpack_require__(1489);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82017);
/* harmony import */ var src_hooks_useExtremeUpgradeRefresh__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57921);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61906);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(5616);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(61730);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_telegram__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29140);
/* harmony import */ var src_core_hooks_useSettings__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51514);
/* harmony import */ var src_core_utils_get_initials__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(83552);
/* harmony import */ var src_core_utils_format__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(59882);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(90948);
/* harmony import */ var src_core_components_icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21609);
/* harmony import */ var src_core_components_telegram_telegram_side_bar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10886);
/* harmony import */ var src_core_components_telegram_telegram_content__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(45733);
/* harmony import */ var src_core_components_telegram_telegram_contacts__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34245);
/* harmony import */ var react_perfect_scrollbar__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(51964);
/* harmony import */ var react_perfect_scrollbar__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react_perfect_scrollbar__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var src_core_components_common_chatCall__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(55574);
/* harmony import */ var _src_api_dashboard__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(95629);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(34745);
/* harmony import */ var src_utils__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(33185);
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(53399);
// ** React Imports






// ** MUI Imports



// ** Store & Actions Imports


// ** Hooks

// ** Utils Imports











// ** Icon Imports

// ** Chat App Components Imports




const PerfectScrollbar = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)((react_perfect_scrollbar__WEBPACK_IMPORTED_MODULE_13___default()))((param)=>{
    let { theme  } = param;
    return {
        padding: theme.spacing(5)
    };
});
// component






const Telegram = ()=>{
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("common");
    // ** States
    const [userStatus, setUserStatus] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("online");
    const [leftSidebarOpen, setLeftSidebarOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [userProfileLeftOpen, setUserProfileLeftOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [userProfileRightOpen, setUserProfileRightOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [advanced, setAdvanced] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true) // 是否购买高级服务
    ;
    const [fetchLoading, setFetchLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true) // 数据获取中
    ;
    // ** Hooks
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)();
    const { settings  } = (0,src_core_hooks_useSettings__WEBPACK_IMPORTED_MODULE_8__/* .useSettings */ .r)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
    const hidden = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(theme.breakpoints.down("lg"));
    const store = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)((state)=>state.Telegram);
    // ** Vars
    const { skin  } = settings;
    const smAbove = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(theme.breakpoints.up("sm"));
    const sidebarWidth = smAbove ? 370 : 300;
    const mdAbove = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(theme.breakpoints.up("md"));
    const [chat, setChat] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const [headImg, setHaedImg] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("/images/telegram/2.jpg");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        dispatch((0,src_store_apps_telegram__WEBPACK_IMPORTED_MODULE_7__/* .fetchUserProfile */ .YI)());
        dispatch((0,src_store_apps_telegram__WEBPACK_IMPORTED_MODULE_7__/* .fetchChatsContacts */ .Pu)());
    }, [
        dispatch
    ]);
    const handleLeftSidebarToggle = ()=>setLeftSidebarOpen((prev)=>!prev);
    const handleUserProfileLeftSidebarToggle = ()=>setUserProfileLeftOpen((prev)=>!prev);
    const handleUserProfileRightSidebarToggle = ()=>setUserProfileRightOpen((prev)=>!prev);
    const [switchDataType, setSwitchDataType] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("activity");
    let selectSwitchDataStyle = {
        background: "#121444",
        color: "#fff",
        display: "inline-block",
        width: "90px",
        height: "26px",
        lineHeight: "26px",
        fontSize: "18px",
        textAlign: "center"
    };
    let switchDataStyle = {
        display: "inline-block",
        width: "90px",
        height: "26px",
        lineHeight: "26px",
        fontSize: "18px",
        textAlign: "center"
    };
    let [chatCallData, setChatCallData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [currentPage, setCurrentPage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1);
    const [total, setTotal] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    // 分页参数
    const [pagination, setPagination] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        reqNum: 50,
        nowOffset: 0,
        maxNum: false // 全部数据查询完毕
    });
    const getChatCallData = async (nowOffset)=>{
        const username = JSON.parse(localStorage.getItem("DeviceUser")) != null ? JSON.parse(localStorage.getItem("DeviceUser")).username : "";
        // 获取最近的10笔订单
        let res = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_18__.getUserAccountOrder)({
            page: 1,
            pageSize: 10
        });
        // 查找有限期最长的订单
        const lastOrder = res.data.sort((a, b)=>dayjs__WEBPACK_IMPORTED_MODULE_5___default()(b.expire_time).valueOf() - dayjs__WEBPACK_IMPORTED_MODULE_5___default()(a.expire_time).valueOf())[0];
        // 计算是否为增值服务上线前付费用户
        // 增值服务上线前付费用户状态更新
        let data = await (0,_src_api_dashboard__WEBPACK_IMPORTED_MODULE_16__/* .getAllDashboard */ .gP)({
            username,
            params: {
                category: "TELEGRAM_INTERACTION",
                offset: nowOffset,
                limit: pagination.reqNum,
                deviceUdid: JSON.parse(localStorage.getItem("currentDevice")) != null ? JSON.parse(localStorage.getItem("currentDevice"))["Unique Identifier"] : ""
            }
        });
        setTotal(data.data.totalCount);
        const advanced = username == null || !("advanced" in data) || [
            "true",
            true
        ].includes(data === null || data === void 0 ? void 0 : data.advanced) // 高级服务开通状态
        ;
        setAdvanced(advanced);
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_17__/* .changeExtremeService */ .xU)(advanced)) // 更新高级服务状态
        ;
        if (data.data.contents == null) {
            setPagination((page)=>({
                    ...page,
                    maxNum: true
                }));
            setFetchLoading(false);
            return;
        }
        let result = data.data.contents.map((row)=>{
            return {
                ...row,
                date: dayjs__WEBPACK_IMPORTED_MODULE_5___default()(row.date).format("YYYY-MM-DD HH:mm:ss"),
                icon: "prime:send",
                color: row.isFromMe ? "#585858" : "#D43538"
            };
        });
        if (!advanced) result = (0,src_utils__WEBPACK_IMPORTED_MODULE_21__/* .generateMockData */ .W)(result);
        setChatCallData((old)=>[
                ...old,
                ...result
            ]);
        setFetchLoading(false);
    };
    // 设备切换时重置列表并重新拉数
    (0,src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_2__/* .useDeviceScopedInit */ .A)((0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        setChatCallData([]);
        setPagination({
            reqNum: 50,
            nowOffset: 0,
            maxNum: false
        });
        setScroll(0);
        setCurrentPage(1);
        setTotal(0);
        setFetchLoading(true);
        getChatCallData(0);
    }, []));
    // 升级成功后重拉本页数据（监听 extreme-upgraded，逻辑对齐 useDeviceScopedInit）
    (0,src_hooks_useExtremeUpgradeRefresh__WEBPACK_IMPORTED_MODULE_3__/* .useExtremeUpgradeRefresh */ .v)((0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        setAdvanced(true);
        setChatCallData([]);
        setPagination({
            reqNum: 50,
            nowOffset: 0,
            maxNum: false
        });
        setScroll(0);
        setCurrentPage(1);
        setTotal(0);
        setFetchLoading(true);
        getChatCallData(0);
    }, []));
    const dom = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    // 滚动百分比
    const [scroll, setScroll] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    // 获取滚动百分比
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handScroll = ()=>{
            if (dom.current) {
                const { scrollTop , scrollHeight , clientHeight  } = dom.current;
                const progress = scrollTop / (scrollHeight - clientHeight) * 100;
                setScroll(progress.toFixed(0));
            }
        };
        const currentRef = dom.current;
        if (currentRef) {
            currentRef.addEventListener("scroll", handScroll);
        }
        return ()=>{
            if (currentRef) {
                currentRef.removeEventListener("scroll", handScroll);
            }
        };
    }, []);
    // 监听滚动百分比
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (scroll >= 100 && advanced) {
            const nowOffset = pagination.nowOffset + pagination.reqNum;
            setPagination((page)=>({
                    ...page,
                    nowOffset
                }));
            if (!pagination.maxNum) getChatCallData(nowOffset);
        }
    }, [
        scroll
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const title = t("Telegram");
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_17__/* .setCurrentTab */ .Lw)(title));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_17__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            switchDataType == "activity" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_common_chatCall__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    dom: dom,
                    data: chatCallData,
                    advanced: advanced,
                    fetchLoading: fetchLoading
                })
            }) : null,
            switchDataType == "chat" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                className: "app-chat",
                sx: {
                    width: "100%",
                    minHeight: "calc(var(--vh)*100 - 370px)",
                    display: "flex",
                    borderRadius: 1,
                    position: "relative",
                    boxShadow: skin === "bordered" ? 0 : 6,
                    ...skin === "bordered" && {
                        border: "1px solid ".concat(theme.palette.divider)
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_telegram_telegram_side_bar__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        store: store,
                        hidden: hidden,
                        mdAbove: mdAbove,
                        dispatch: dispatch,
                        userStatus: userStatus,
                        selectMessage: src_store_apps_telegram__WEBPACK_IMPORTED_MODULE_7__/* .selectMessage */ .rT,
                        getInitials: src_core_utils_get_initials__WEBPACK_IMPORTED_MODULE_23__/* .getInitials */ .Q,
                        sidebarWidth: sidebarWidth,
                        setUserStatus: setUserStatus,
                        leftSidebarOpen: leftSidebarOpen,
                        removeSelectedChat: src_store_apps_telegram__WEBPACK_IMPORTED_MODULE_7__/* .removeSelectedChat */ .sr,
                        userProfileLeftOpen: userProfileLeftOpen,
                        formatDateToMonthShort: src_core_utils_format__WEBPACK_IMPORTED_MODULE_24__/* .formatDateToMonthShort */ .oS,
                        handleLeftSidebarToggle: handleLeftSidebarToggle,
                        handleUserProfileLeftSidebarToggle: handleUserProfileLeftSidebarToggle,
                        headImg: headImg,
                        setChat: setChat,
                        chat: chat,
                        setHaedImg: setHaedImg
                    }),
                    chat && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_telegram_telegram_content__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        store: store,
                        hidden: hidden,
                        mdAbove: mdAbove,
                        dispatch: dispatch,
                        getInitials: src_core_utils_get_initials__WEBPACK_IMPORTED_MODULE_23__/* .getInitials */ .Q,
                        sidebarWidth: sidebarWidth,
                        userProfileRightOpen: userProfileRightOpen,
                        handleLeftSidebarToggle: handleLeftSidebarToggle,
                        handleUserProfileRightSidebarToggle: handleUserProfileRightSidebarToggle,
                        headImg: headImg,
                        setHaedImg: setHaedImg
                    }),
                    chat === false ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_telegram_telegram_contacts__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        store: store,
                        hidden: hidden,
                        mdAbove: mdAbove,
                        dispatch: dispatch,
                        getInitials: src_core_utils_get_initials__WEBPACK_IMPORTED_MODULE_23__/* .getInitials */ .Q,
                        sidebarWidth: sidebarWidth,
                        userProfileRightOpen: userProfileRightOpen,
                        handleLeftSidebarToggle: handleLeftSidebarToggle,
                        handleUserProfileRightSidebarToggle: handleUserProfileRightSidebarToggle,
                        headImg: headImg,
                        setHaedImg: setHaedImg
                    }) : ""
                ]
            }) : null
        ]
    });
};
Telegram.contentHeightFixed = true;
/* harmony default export */ __webpack_exports__["default"] = (Telegram);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,9830,5170,1954,518,2862,770,2607,6664,210,8863,1964,6853,7891,1558,2159,5983,3769,6719,1919,9774,2888,179], function() { return __webpack_exec__(54071); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);